/*
 grow_2629_forms_pricing_page_marketing
	MT1: https://admin.monkeytest1.com/experiments/surveymonkey/1884
	MT2: https://admin.monkeytest2.com/experiments/surveymonkey/1321
	MT3:  https://admin.monkeytest3.com/experiments/surveymonkey/698904

	This experiment treatment has the same UI as grow-2529
	but the package costs returned by the API are different.
 */
import Package from '../grow_2529_forms/treatment1/Package';
import DetailsPackageHeader from '../grow_2529_forms/components/DetailsPackageHeader';
import MoreAbout from '../grow_2529_forms/components/PricingFooter/MoreAbout';

export default {
  Package,
  DetailsPackageHeader,
  MoreAbout,
};
